module.exports = __webpack_public_path__ + "img/logo.e7ef1eb2.png";